/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeInputBooleanButtonOn } from "../../d-input-boolean-button-on";
import { DStateAwareOrValueMightBe } from "../../d-state-aware";
import { DThemeWhiteButton } from "./d-theme-white-button";

export abstract class DThemeWhiteInputBooleanButtonOn
	extends DThemeWhiteButton<string>
	implements DThemeInputBooleanButtonOn
{
	isToggle(): boolean {
		return true;
	}

	abstract newTextValue(): DStateAwareOrValueMightBe<string>;
}
